import { ReactNode } from 'react'
import cx from 'classnames'

export default ({ title, margin }: { title: ReactNode, margin?: string }): JSX.Element => (
  <h2
    className={cx('black fw6 lighter pt2 f3 mt0-t ', margin !== undefined ? margin : 'mt8 mb8 mt4-m')}
  >{title}
  </h2>
)
